"use client";

import * as React from "react";
import { Play, ChevronDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger, DialogTitle, DialogDescription } from "@/components/ui/dialog";
export default function TheGrandPremiere() {
  return <section data-section-id="223302" id="the-gold-standard-of-football" className="relative flex min-h-screen w-full flex-col items-center justify-center overflow-hidden bg-background text-foreground">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/birks photo.jpg" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/birks photo.jpg-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/birks photo.jpg-wvc-sizes" alt="WT Birkalla match highlights" className="h-full w-full object-cover opacity-60 grayscale-[60%]" loading="lazy" />
        <div className="absolute inset-0 bg-black/40" />
      </div>

      {}
      <div className="relative z-10 flex flex-col items-center px-4 text-center">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1654193/img/Untitled design (8).png" className="h-40 w-auto object-contain mb-8 drop-shadow-lg" alt="Birks Logo" />
        <h1 className="font-default text-6xl font-extrabold tracking-tighter text-primary sm:text-7xl md:text-8xl lg:text-9xl lg:leading-none uppercase">
          The Gold Standard
        </h1>
        <p className="mt-6 font-default text-xl font-medium tracking-wide text-primary md:text-3xl">
          Excellence in Football Since 1933.
        </p>

        {}
        <Dialog>
          <DialogTrigger asChild>
            <Button variant="default" className="mt-12 h-24 w-24 rounded-sm bg-primary text-primary-foreground shadow-2xl transition-transform hover:scale-105 border-2 border-primary" aria-label="Play Showreel">
              <Play className="ml-1 h-10 w-10 fill-current" />
            </Button>
          </DialogTrigger>
          <DialogContent className="max-w-5xl border-none bg-card p-0 shadow-4xl">
            <DialogTitle className="sr-only">Club Showreel</DialogTitle>
            <DialogDescription className="sr-only">
              A cinematic showcase of WT Birkalla's footballing excellence and community spirit.
            </DialogDescription>
            <div className="relative aspect-video w-full overflow-hidden rounded-none bg-muted">
              {}
              <div className="absolute inset-0 flex items-center justify-center bg-background/80 backdrop-blur-md">
                <span className="font-mono text-lg tracking-widest text-primary">
                  [ LOADING BIRKALLA_REEL.MP4 ]
                </span>
              </div>
            </div>
          </DialogContent>
        </Dialog>
      </div>

      {}
      <div className="absolute bottom-12 left-1/2 z-10 -translate-x-1/2 animate-bounce text-primary">
        <ChevronDown className="h-12 w-12 opacity-100" />
      </div>
    </section>;
}